import React, { FC } from 'react';
import { Layout } from 'antd';

import Sider from '../Sider';
import { DesktopHeader } from '../Header';

const DesktopLayout: FC = (props) => {
  const { children } = props;
  return (
    <>
      <Sider />
      <Layout>
        <DesktopHeader />
        <Layout.Content className="App-Content">{children}</Layout.Content>
      </Layout>
    </>
  );
};

export default DesktopLayout;
